/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from "styled-components";

export const ColouredBackground = styled.div`
  min-height: 120vh;
  min-width: 100vw;
  position: fixed;
  margin-left: -20px;
  top: 0;
  z-index: -2;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100% 100%;
`;
